import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createScheduleBlock, deleteScheduleBlock, fetchScheduleBlocks } from '@/lib/scheduleBlocks';

function localInput(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function ScheduleBlocks() {
  const queryClient = useQueryClient();
  const tomorrow = new Date(Date.now() + 24 * 3600_000);
  tomorrow.setHours(10, 0, 0, 0);
  const endDefault = new Date(tomorrow.getTime() + 60 * 60_000);
  const [staffId, setStaffId] = useState('');
  const [startsAt, setStartsAt] = useState(localInput(tomorrow));
  const [endsAt, setEndsAt] = useState(localInput(endDefault));
  const [reason, setReason] = useState('');
  const { data, isLoading } = useQuery({ queryKey: ['schedule-blocks'], queryFn: fetchScheduleBlocks });
  const refresh = () => queryClient.invalidateQueries({ queryKey: ['schedule-blocks'] });
  const create = useMutation({
    mutationFn: () => createScheduleBlock({
      staffId: staffId || null,
      startsAt: new Date(startsAt).toISOString(),
      endsAt: new Date(endsAt).toISOString(),
      reason
    }),
    onSuccess: async () => { setReason(''); await refresh(); }
  });
  const remove = useMutation({ mutationFn: deleteScheduleBlock, onSuccess: refresh });

  return (
    <section className="mnc-admin-panel">
      <div className="mnc-admin-panel-head">
        <div><span className="mnc-eyebrow">Исключения</span><h2>Перерывы и выходные</h2></div>
      </div>
      <p className="mnc-muted">Закройте время для всего салона или конкретного мастера. Эти интервалы сразу исчезнут из онлайн-записи.</p>
      <div className="mnc-block-form">
        <label className="mnc-field">Кого закрыть
          <select value={staffId} onChange={(event) => setStaffId(event.target.value)}>
            <option value="">Весь салон</option>
            {data?.staff.map((member) => <option key={member.id} value={member.id}>{member.name}</option>)}
          </select>
        </label>
        <label className="mnc-field">Начало
          <input type="datetime-local" value={startsAt} onChange={(event) => setStartsAt(event.target.value)} />
        </label>
        <label className="mnc-field">Конец
          <input type="datetime-local" value={endsAt} onChange={(event) => setEndsAt(event.target.value)} />
        </label>
        <label className="mnc-field">Причина
          <input value={reason} onChange={(event) => setReason(event.target.value)} placeholder="Отпуск, обед, больничный" />
        </label>
        <button className="mnc-btn" disabled={create.isPending || !startsAt || !endsAt} onClick={() => create.mutate()}>
          Закрыть время
        </button>
      </div>
      {(create.isError || remove.isError) && <p className="mnc-error">{(create.error ?? remove.error)?.message}</p>}
      {isLoading ? <p className="mnc-muted">Загружаем исключения…</p> : (
        <ul className="mnc-list mnc-block-list">
          {data?.blocks.length === 0 && <li><span className="mnc-muted">Будущих исключений нет.</span></li>}
          {data?.blocks.map((block) => (
            <li key={block.id}>
              <span><b>{block.staff_name ?? 'Весь салон'}</b><br /><small className="mnc-muted">{block.reason || 'Без комментария'}</small></span>
              <span className="mnc-when">
                {new Date(block.starts_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                {' — '}
                {new Date(block.ends_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
              </span>
              <button className="mnc-linklike is-danger" disabled={remove.isPending} onClick={() => remove.mutate(block.id)}>Удалить</button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
